import { Dialog } from "@headlessui/react";
import { AnimatePresence, motion } from "framer-motion";
import { useTranslations } from "next-intl";

import { useSearch } from "~/contexts/search";

import Icon from "../common/icon";
import styles from "./category-sort-dialog.module.scss";

type Props = {
  isOpen: boolean;
  setOpen: (value: boolean) => void;
};

export default function SearchSortDialog(props: Props) {
  const t = useTranslations();
  const { setSort } = useSearch();

  function selectSort(descriptor: EVA.Core.SortFieldDescriptor) {
    setSort([descriptor]);
    props.setOpen(false);
  }

  return (
    <AnimatePresence>
      {props.isOpen ? (
        <Dialog className={styles.container} open={props.isOpen} onClose={() => props.setOpen(false)}>
          <motion.div
            className={styles.backdrop}
            aria-hidden
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          />
          <motion.div
            className={styles.wrapper}
            initial={{ translateY: "100%" }}
            animate={{ translateY: 0 }}
            exit={{ translateY: "100%" }}
            transition={{ duration: 0.3 }}
          >
            <Dialog.Panel className={styles.panel}>
              <div className={styles.top}>
                <div className={styles.header}>
                  <Icon name="sort" width={20} height={20} />
                  <Dialog.Title className={styles.title}>{t("generic.sort_by")}</Dialog.Title>
                </div>
                <button aria-label={t("generic.close")} className={styles.close} onClick={() => props.setOpen(false)}>
                  <Icon name="close" width={20} height={20} />
                </button>
              </div>
              <div className={styles.content}>
                <p className={styles.subtitle}>{t("generic.categories.filters.heading_highlights")}</p>
                <div className={styles.grid}>
                  <button
                    className={styles.option}
                    onClick={() => selectSort({ FieldName: "sellable_since", Direction: 1 })}
                  >
                    {t("generic.categories.filters.new_in")}
                  </button>
                  <button
                    className={styles.option}
                    onClick={() => selectSort({ FieldName: "review_average_score", Direction: 1 })}
                  >
                    {t("generic.categories.filters.top_rated")}
                  </button>
                </div>
                <p className={styles.subtitle}>{t("generic.categories.filters.heading_price")}</p>
                <div className={styles.grid}>
                  <button
                    className={styles.option}
                    onClick={() => selectSort({ FieldName: "display_price", Direction: 1 })}
                  >
                    {t("generic.categories.filters.price_high_to_low")}
                  </button>
                  <button
                    className={styles.option}
                    onClick={() => selectSort({ FieldName: "display_price", Direction: 0 })}
                  >
                    {t("generic.categories.filters.price_low_to_high")}
                  </button>
                </div>
                <p className={styles.subtitle}>{t("generic.categories.filters.heading_name")}</p>
                <div className={styles.grid}>
                  <button
                    className={styles.option}
                    onClick={() => selectSort({ FieldName: "display_value", Direction: 0 })}
                  >
                    {t("generic.categories.filters.name_a_to_z")}
                  </button>
                  <button
                    className={styles.option}
                    onClick={() => selectSort({ FieldName: "display_value", Direction: 1 })}
                  >
                    {t("generic.categories.filters.name_z_to_a")}
                  </button>
                </div>
              </div>
            </Dialog.Panel>
          </motion.div>
        </Dialog>
      ) : null}
    </AnimatePresence>
  );
}
